import * as React from 'react';
import { useSelector } from 'react-redux';

import { IRegularInfrastructureData } from '../../../types/map';
import { getIsMapServicesEnabled, getIsTransportAccessibilityServiceAvailable } from '../../../selectors/mapServices';
import { trackInfrastructureShow } from '../analytics';
import { toRegularInfrastructureItems } from '../helpers/mappers';
import { selectIsInfrastructureFetched } from '../../../selectors/infrastructure';

/**
 * Отправляет событие показа не раньше, чем инфраструктура будет извлечена,
 * чтобы отправить в событии показа корректные параметры.
 */
export const useInfrastructureShowHandler = (
  infrastructureMapRef: React.MutableRefObject<Map<number, IRegularInfrastructureData>>,
) => {
  const isMapServicesEnabled = useSelector(getIsMapServicesEnabled);
  const isTransportAccessibilityServiceAvailable = useSelector(getIsTransportAccessibilityServiceAvailable);
  const isInfrastructureFetched = useSelector(selectIsInfrastructureFetched);

  const wasShownRef = React.useRef(false);
  const isInfrastructureFetchedRef = React.useRef(isInfrastructureFetched);

  const handleShow = React.useCallback(() => {
    const infrastructureItems = toRegularInfrastructureItems(infrastructureMapRef.current);
    trackInfrastructureShow(infrastructureItems, isMapServicesEnabled, isTransportAccessibilityServiceAvailable);
  }, [isMapServicesEnabled, isTransportAccessibilityServiceAvailable]);

  React.useEffect(() => {
    isInfrastructureFetchedRef.current = isInfrastructureFetched;

    if (wasShownRef.current && isInfrastructureFetchedRef.current) {
      handleShow();
    }
  }, [isInfrastructureFetched]);

  return React.useCallback(() => {
    wasShownRef.current = true;

    if (isInfrastructureFetchedRef.current) {
      handleShow();
    }
  }, []);
};
